import { render } from "./AppCheckbox.vue?vue&type=template&id=31a647df&scoped=true&ts=true"
import script from "./AppCheckbox.vue?vue&type=script&lang=ts"
export * from "./AppCheckbox.vue?vue&type=script&lang=ts"

import "./AppCheckbox.vue?vue&type=style&index=0&id=31a647df&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a647df"]])

export default __exports__